import { useContext } from "react";
import { AuthContext } from "../providers";

/**
 * Hook that returns the authentication context value
 * 
 * @returns The authentication context
 */
const useAuth = () => {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return authContext;
};

export default useAuth;
